'use client';

import * as React from 'react';

import { cn } from '@/lib/utils';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from '@/components/ui/input-group';
import { Eye, EyeOff } from 'lucide-react';

interface PasswordInputProps
  extends Omit<React.ComponentProps<typeof InputGroupInput>, 'type'> {
  groupClassName?: string;
  toggleClassName?: string;
}

export const PasswordInput = React.forwardRef<
  HTMLInputElement,
  PasswordInputProps
>(function PasswordInput(
  { disabled, groupClassName, toggleClassName, ...props },
  ref
) {
  const [isVisible, setIsVisible] = React.useState(false);

  return (
    <InputGroup
      className={groupClassName}
      data-disabled={disabled ? true : undefined}
    >
      <InputGroupInput
        {...props}
        ref={ref}
        type={isVisible ? 'text' : 'password'}
        disabled={disabled}
      />
      <InputGroupAddon
        align="inline-end"
        className="px-2 py-0 has-[>button]:mr-0"
      >
        <InputGroupButton
          type="button"
          variant="ghost"
          size="icon-sm"
          onClick={() => setIsVisible((currentValue) => !currentValue)}
          disabled={disabled}
          aria-label={isVisible ? 'Hide password' : 'Show password'}
          aria-pressed={isVisible}
          className={cn(
            'text-muted-foreground hover:text-foreground size-8',
            toggleClassName
          )}
        >
          {isVisible ? (
            <EyeOff className="size-5" />
          ) : (
            <Eye className="size-5" />
          )}
        </InputGroupButton>
      </InputGroupAddon>
    </InputGroup>
  );
});
